"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_REPORT_GRANULARITY = exports.DEFAULT_REPORT_RANGE_DAYS = void 0;
exports.defaultReportPeriod = defaultReportPeriod;
var time_1 = require("./time");
// A report dashboard's first load spans several weeks so its charts have a trend to
// draw; a month-to-date range in monthly buckets plotted a single point early in the
// month and looked broken.
exports.DEFAULT_REPORT_RANGE_DAYS = 90;
exports.DEFAULT_REPORT_GRANULARITY = 'weekly';
function defaultReportPeriod(today) {
    if (today === void 0) { today = new Date(); }
    return {
        start_date: (0, time_1.toYMD)((0, time_1.subtractDays)(today, exports.DEFAULT_REPORT_RANGE_DAYS)),
        end_date: (0, time_1.toYMD)(today),
        granularity: exports.DEFAULT_REPORT_GRANULARITY,
    };
}
